import KidWidget from'./KIDWidget';export default KidWidget;